<template>
  <v-container grid-list-md text-xs-center>
    <br />
    <v-layout row wrap>

      <v-flex xs4>
        <v-card
          elevation="8"
          style="margin: 10px; padding: 10px 10px 10px 10px;"
          class="mx-auto"
          max-width="344"
          outlined
        >
          <v-card-title style="">
            <h2>
              Manual Insert: Sold Register Record
            </h2>
          </v-card-title>
          <v-flex>
            <form>
              <v-text-field
                style="margin: 10px"
                v-model="card_no"
                label="Card No"
              ></v-text-field>
              <v-btn
                stlye="text-align: center"
                @click="runManualInsertSoldRegister(card_no)"
                >submit</v-btn
              >
            </form>
          </v-flex>
        </v-card>
      </v-flex>

            <v-flex xs4>
        <v-card
          elevation="8"
          style="margin: 10px; padding: 10px 10px 10px 10px;"
          class="mx-auto"
          max-width="344"
          outlined
        >
          <v-card-title style="">
            <h2>
              Manual Insert: Credit Redeem Record
            </h2>
          </v-card-title>
          <v-flex>
            <form>
              <v-text-field
                style="margin: 10px"
                v-model="card_no_man_credit_redeem"
                label="Card No"
              ></v-text-field>
              <v-btn
                stlye="text-align: center"
                @click="runManualInsertCreditRedeem(card_no_man_credit_redeem)"
                >submit</v-btn
              >
            </form>
          </v-flex>
        </v-card>
      </v-flex>
      <!-- Manual Insert Aggregate: Basic -->
      <v-flex xs4>
        <v-card
          elevation="8"
          style="margin: 10px; padding: 10px 10px 10px 10px;"
          class="mx-auto"
          max-width="344"
          outlined
        >
          <v-card-title style="">
            <v-flex md12>
              <h2>
                Manual Insert Aggregate: Basic
              </h2>
              <h2>
                (Card Transactions only)
              </h2>
            </v-flex>
          </v-card-title>
          <v-flex>
            <v-layout>
              <v-flex md12 style="padding: 0 5px;">
                <v-text-field
                  style="margin: 10px"
                  v-model="manual_insert_aggre_basic_card_no"
                  label="Card No"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6 style="padding: 0 5px;">
                <v-menu
                  ref="dateFromMenu"
                  :close-on-content-click="false"
                  v-model="dateFromMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="dateTo"
                    min="1950-01-01"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex md6 style="padding: 0 5px;">
                <v-menu
                  ref="dateToMenu"
                  :close-on-content-click="false"
                  v-model="dateToMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="dateToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>

            <v-btn
              stlye="text-align: center"
              @click="runManualInsertAggreateCardTrans()"
              >submit</v-btn
            >
          </v-flex>
        </v-card>
      </v-flex>
      <!-- End of Manual Insert Aggregate: Basic  -->

      <!-- Manual Insert Aggregate: Time Ranged -->
      <v-flex xs4>
        <v-card
          elevation="8"
          style="margin: 10px; padding: 10px 10px 10px 10px;"
          class="mx-auto"
          max-width="344"
          outlined
        >
          <v-card-title style="">
            <v-flex md12>
              <h2>
                Manual Insert Aggregate: Time Ranged
              </h2>
              <h2>
                (Card Transactions only)
              </h2>
            </v-flex>
          </v-card-title>
          <br />
          <v-flex>
            <v-flex md12 style="padding: 0 5px;">
              <v-menu
                ref="dateTrMenu"
                :close-on-content-click="false"
                v-model="dateTrMenu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTr"
                  label="Select Date"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>

                <v-date-picker
                  ref="picker"
                  v-model="dateTr"
                  :max="maxDateTr"
                  min="1950-01-01"
                  @input="dateTrMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-layout>
              <v-flex md6 style="padding: 0 5px;">
                <v-menu
                  ref="timeFromMenu"
                  :close-on-content-click="false"
                  v-model="timeFromMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="timeFrom"
                    label="Time From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-time-picker
                    ref="picker"
                    v-model="timeFrom"
                    @mouseup="timeFromMenu = false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>

              <v-flex md6 style="padding: 0 5px;">
                <v-menu
                  ref="timeToMenu"
                  :close-on-content-click="false"
                  v-model="timeToMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="timeTo"
                    label="Time To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-time-picker
                    ref="picker"
                    v-model="timeTo"
                    @mouseup="timeToMenu = false"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-btn
              stlye="text-align: center"
              @click="runTimeRangedInsertAggreateCardTrans()"
              >submit</v-btn
            >
          </v-flex>
        </v-card>
      </v-flex>
      <!-- End of Manual Insert Aggregate: Time Ranged -->

      <!-- Check Duplicates -->
      <!-- End of Check Duplicate -->

      <!-- Check Operations Audit -->
      <v-flex md12>
        <v-card
          elevation="8"
          style="margin: 10px; padding: 10px 10px 10px 10px;"
          class="mx-auto"
          max-width="100%"
          outlined
        >
          <v-card-title>
            <v-spacer></v-spacer>
            <refresh-button @refresh="setOpsAuditList()"></refresh-button>
            <v-flex md12>
              <h2>
                OPERATIONS AUDIT LIST
              </h2>
            </v-flex>
          </v-card-title>
          <br />
          <v-flex>
            <v-flex md12 style="size:100%">
              <v-data-table
                :headers="opsAuditHeaders"
                :items="opsAuditData"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-right">
                    {{
                      props.item.time && props.item.date
                        ? $dateFormat(
                            props.item.time + " " + props.item.date,
                            "YYYY-MM-DD HH:mm:ss"
                          )
                        : "--"
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.operation ? props.item.operation : "--" }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      props.item.affected_records
                        ? props.item.affected_records
                        : "--"
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.server_name ? props.item.server_name : "--" }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.ip ? props.item.ip : "--" }}
                  </td>
                  <td class="text-xs-center">
                    <strong>
                      <p
                        v-if="props.item.status == '0011'"
                        style="color:green; font-size:100%"
                      >
                        SUCCESS
                      </p>
                      <p
                        v-else-if="props.item.status == '0000'"
                        style="color:red; font-size:100%"
                      >
                        ERROR
                      </p>
                      <p
                        v-else-if="props.item.status == '0012'"
                        style="color:red; font-size:100%"
                      >
                        NO CHANGES
                      </p>
                      <p
                        v-else-if="props.item.status == '0013'"
                        style="color:orange; font-size:100%"
                      >
                        PENDING
                      </p>
                    </strong>
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.remarks ? props.item.remarks : "--" }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-card>
      </v-flex>
      <!-- End of Check Operations -->
    </v-layout>
  </v-container>
</template>
<script>
import Services from "@/services/Services";
import moment from "moment";
var now = new Date();
const yesterday = now.setDate(now.getDate() - 1);
export default {
  components: {},
  data() {
    return {
      check_duplicates_card_no: "",
      check_duplicates_date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      check_duplicates_date_to: this.$dateFormat(now, "YYYY-MM-DD"),

      // check_duplicates_trans_type: "",
      //
      card_no: "",
      card_no_man_credit_redeem: "",
      manual_insert_aggre_basic_card_no: "",
      manual_insert_aggre_card_no: "",
      manual_insert_aggre_tr_card_no: "",
      dateFrom: this.$dateFormat(yesterday, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(yesterday, "YYYY-MM-DD"),
      dateTr: this.$dateFormat(yesterday, "YYYY-MM-DD"),
      timeFrom: this.$dateFormat(yesterday, "HH:mm"),
      timeTo: this.$dateFormat(yesterday, "HH:mm"),
      maxTimeTo: this.$dateFormat(yesterday, "HH:mm"),
      maxDateTr: this.$dateFormat(yesterday, "YYYY-MM-DD"),
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      dateTrMenu: false,
      duplicate_data: [],
      opsAuditData: [],
      opsAuditParams: {
        offset: 0,
        limit: 0,
        dateFrom: null,
        dateTo: null,
      },
      opsAuditHeaders: [
        {
          text: "Date / Time",
          align: "center",
          sortable: false,
          value: "date",
        },
        {
          text: "Operation",
          align: "center",
          sortable: false,
          value: "ops",
        },
        {
          text: "Affected Records",
          align: "center",
          sortable: false,
          value: "a_r",
        },
        {
          text: "Service Name",
          align: "center",
          sortable: false,
          value: "time",
        },
        {
          text: "IP Address",
          align: "center",
          sortable: false,
          value: "ip",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "Remarks",
          align: "center",
          sortable: false,
          value: "remarks",
        },
      ],
      headers: [
        {
          text: "Card No.",
          align: "left",
          sortable: false,
          value: "card_no",
        },
        {
          text: "Duplicate Count",
          align: "left",
          sortable: false,
          value: "dup_count",
        },
      ],
    };
  },
  created() {
    this.setOpsAuditList();
  },
  // computed: {
  //   opsAuditPageLimit: {
  //     get() {
  //       return 10;
  //     },
  //     set(val) {
  //       this.opsAuditParams.limit = val;
  //       this.opsAuditParams.offset = 0;
  //     },
  //   },
  // },
  methods: {
    async setOpsAuditList() {
      this.$store.dispatch("startLoading");
      try {
        const response = await Services.getOperationsAuditData({
          limit: this.opsAuditParams.limit,
        });
        this.opsAuditData = response.data.data;
      } catch (error) {
        console.log(error);
        this.$infoBar({
          type: "error",
          text: "Error on Request",
        });
      }
      this.$store.dispatch("endLoading");
    },
    async runManualInsertAggreateCardTrans() {
      this.$store.dispatch("startLoading");

      try {
        const manual_insert_aggre = await Services.manualInsertAggreCard({
          card_no: this.manual_insert_aggre_basic_card_no,
          date_from: this.dateFrom,
          date_to: this.dateTo,
        });

        if (manual_insert_aggre.status == 200) {
          if (manual_insert_aggre.data.status == "0013") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "info",
              text: "Your Request Is Now Processing",
            });
          } else if (manual_insert_aggre.data.status == "0012") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "info",
              text: "Manual Aggeration: Has Overlap!",
            });
          }
        } else if (manual_insert_aggre.status == 500) {
          if (manual_insert_aggre.data.status == "0021") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Invalid Parameter",
            });
          } else if (manual_insert_aggre.data.status == "0000") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Error On Ops Audit Query",
            });
          }
        } else {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "No Network / Server Connection",
          });
        }
      } catch (error) {
        this.$store.dispatch("endLoading");
        return this.$infoBar({
          type: "error",
          text: "No Network / Server Connection",
        });
      }
    },
    async runTimeRangedInsertAggreateCardTrans() {
      this.$store.dispatch("startLoading");

      try {
        const manual_insert_aggre = await Services.manualTimeRangedInsertAggreCard(
          {
            date: this.dateTr,
            time_from: this.timeFrom,
            time_to: this.timeTo,
          }
        );

        if (manual_insert_aggre.status == 200) {
          if (manual_insert_aggre.data.status == "0013") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "info",
              text: "Your Request Is Now Processing",
            });
          } else if (manual_insert_aggre.data.status == "0012") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "info",
              text: "Manual Aggeration: Has Overlap!",
            });
          }
        } else if (manual_insert_aggre.status == 500) {
          if (manual_insert_aggre.data.status == "0021") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Invalid Parameter",
            });
          } else if (manual_insert_aggre.data.status == "0000") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Error On Ops Audit Query",
            });
          }
        } else {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "No Network / Server Connection",
          });
        }
      } catch (error) {
        this.$store.dispatch("endLoading");
        return this.$infoBar({
          type: "error",
          text: "No Network / Server Connection",
        });
      }
    },
    async runManualInsertSoldRegister(data) {
      let manualInsertResp = null;
      try {
        this.$store.dispatch("startLoading");
        const card_no = data.trim();
        if (card_no == null || card_no == undefined || card_no == "") {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "Please input Card no!",
          });
        }
        const response = await Services.getSoldTransaction(card_no);

        if (response.status == 200) {
          if (response.data.has_trans == false) {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Card Has No Sold Credit Sync Record!",
            });
          }

          let param = {
            card_number: card_no,
            sold_date: moment(response.data.transaction_date).format(
              "YYYY-MM-DD"
            ),
            sold_time: moment(response.data.transaction_date).format(
              "HH:mm:ss"
            ),
            employee_id: response.data.data.user.id,
            setting_version: response.data.version,
          };
          manualInsertResp = await Services.manualInsertSoldRegTransaction(param);
          if (manualInsertResp.status == 200) {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "success",
              text: "Record Created!",
            });
          }
        } else {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      } catch (error) {
        let error_message = "No network or server connection";

        if (error.response.status == "501") {
          error_message = "Card already exist.";
        }
        this.$store.dispatch("endLoading");
        return this.$infoBar({
          type: "error",
          text: error_message,
        });
      }
    },
    async checkDuplicateData() {
      this.$store.dispatch("startLoading");

      try {
        const response = await Services.getDuplicateData({
          cardnumber,
          transaction_date_from,
          transaction_date_to,
          transaction_type,
        });

        if (response.status == 200) {
          if (response.data.status == "0012") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "info",
              text: "Data Available",
            });
          }
        } else if (response.status == 500) {
          if (response.data.status == "0021") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Invalid Parameter",
            });
          } else if (response.data.status == "0000") {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Error On Query",
            });
          }
        } else {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "No Network / Server Connection",
          });
        }
      } catch (error) {
        this.$store.dispatch("endLoading");
        return this.$infoBar({
          type: "error",
          text: "No Network / Server Connection",
        });
      }
    },
        async runManualInsertCreditRedeem(data) {
      let manualInsertResp = null;
      try {
        this.$store.dispatch("startLoading");
        const card_no = data.trim();
        if (card_no == null || card_no == undefined || card_no == "") {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "Please input Card no!",
          });
        }
        const response = await Services.getSoldTransaction(card_no);

        if (response.status == 200) {
          if (response.data.has_trans == false) {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "error",
              text: "Card Has No Sold Credit Sync Record!",
            });
          }

          let param = {
            card_number: card_no,
            sold_date: moment(response.data.transaction_date).format(
              "YYYY-MM-DD"
            ),
            sold_time: moment(response.data.transaction_date).format(
              "HH:mm:ss"
            ),
            employee_id: response.data.data.user.id,
            setting_version: response.data.version,
          };
          manualInsertResp = await Services.manualInsertCreditRedeem(param);
          if (manualInsertResp.status == 200) {
            this.$store.dispatch("endLoading");
            return this.$infoBar({
              type: "success",
              text: "Record Created!",
            });
          }
        } else {
          this.$store.dispatch("endLoading");
          return this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      } catch (error) {
        let error_message = "No network or server connection";

        if (error.response.status == "501") {
          error_message = "Card already exist.";
        }
        this.$store.dispatch("endLoading");
        return this.$infoBar({
          type: "error",
          text: error_message,
        });
      }
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
